/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Scene_Description_Import_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to import shot descriptions: {error}" |
*
* @param {Scene_Description_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_description_import_failed = /** @type {((inputs: Scene_Description_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Description_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l'importation des descriptions de plans : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler beim Importieren der Shot-Beschreibungen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile importare le descrizioni delle inquadrature: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать описания кадров: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar las descripciones de las tomas: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入镜头描述失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ショットの説明のインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शॉट विवरण आयात करने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao importar as descrições das fotos: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to import shot descriptions: ${i?.error}`)
});